export default __webpack_public_path__ + "static/media/egoeast.fed7078a.svg";